import Home from './home/'
import CourseList from './home/CourseList'
// Grouping Components in the Same Chunk
const NotFound = () => import(/* webpackChunkName: "NotFound" */ './general/404')
const MyCourse = () => import(/* webpackChunkName: "MyCourse" */ './home/MyCourse')
const MyClass = () => import(/* webpackChunkName: "MyClass" */ './home/MyClass')
const MyCourseInfo = () => import(/* webpackChunkName: "MyCourseInfo" */ './classDetail/MyCourseInfo')
const ClassDetail = () => import(/* webpackChunkName: "ClassDetail" */ './classDetail/')
const MyCoupon = () => import(/* webpackChunkName: "MyCoupon" */ './home/MyCoupon')
const VipCard = () => import(/* webpackChunkName: "VipCard" */ './home/VipCard')
const Lecture = () => import(/* webpackChunkName: "Lecture" */ './home/Lecture')
const Pay = () => import(/* webpackChunkName: "Pay" */ './pay/')
const Confirm = () => import(/* webpackChunkName: "Confirm" */ './pay/confirm')
const OrderInfo = () => import(/*  webpackChunkName: "OrderInfo" */ './pay/orderInfo')
const GroupActivity = () => import(/* webpackChunkName: "GroupActivity" */ './GroupActivity/')
const CouponActivity = () => import(/* webpackChunkName: "CouponActivity" */ './CouponActivity/')
const LearningSituation = () => import(/* webpackChunkName: "LearningSituation" */ './LearningSituation/')
const GetProton = () => import(/* webpackChunkName: "GetProton" */ './PublicActivities/GetProton')
const Live = () => import(/* webpackChunkName: "Live" */ './live/index.vue')
const Cart = () => import(/* webpackChunkName: "Cart" */ './pay/cart')
const OfflineLive = () => import(/* webpackChunkName: "OfflineLive" */ './live/OfflineLive.vue')
const Union = () => import(/* webpackChunkName: "Union" */ './LianBao/UnionIndex.vue')
const Protons = () => import(/* webpackChunkName: "Protons" */ './User/ProtonsIndex.vue')

/* 组件导出分为两类, 一类常用的直接导出，另一类诸如Login, Logout等用懒加载,懒加载不在此处导出
 *   在对应的route内加载
 *   见https://router.vuejs.org/en/advanced/lazy-loading.html
 */
export { Home, MyClass, MyCourse, CourseList, Lecture, MyCoupon, VipCard, ClassDetail, MyCourseInfo, Pay, Cart, NotFound, Confirm, OrderInfo, GroupActivity, CouponActivity, LearningSituation, GetProton, Live, OfflineLive, Union, Protons }
